export default __webpack_public_path__ + "static/media/imperialHover.be8c07fe.svg";